import styled from 'styled-components';
import {Button, Collapse} from 'antd';
import Card from '../../../../../Card';
import {typographyStyles} from '../../../../../../utils/styles';

const StyledExpenseDetails = styled(Card)`
  .ant-divider {
    margin: 16px 0;
  }

  .ant-form-item {
    margin-bottom: 0;
    width: 100%;

    .ant-input,
    .ant-input-affix-wrapper,
    .ant-picker {
      &:not(:active):not(:focus):not(:hover) {
        border-color: transparent;
      }
    }

    .ant-input {
      min-width: 50px;
      max-width: 220px;
      text-align: right;
    }
  }

  .ant-card-head {
    a {
      display: flex;

      svg {
        height: 10px;
        transition: .2s;
        width: 10px;
        path {
          fill: ${props => props.theme.colors.neutral_10};
        }
      }

      &:hover {
        svg {
          opacity: 0.6;
        }
      }
    }
  }

  table {
    tbody {
      tr {
        td {
          display: flex;
          &:nth-child(1) {
            text-wrap: nowrap;
          }
          &:nth-child(2) {
            display: flex;
            justify-content: end;
            width: 100%;
          }
        }
      }
    }
  }

  .expense-details-tags-select {
    width: 100%;
    display: flex;
    justify-content: end;
  }
`;

const StyledExpenseDetailsButton = styled(Button)`
  margin-bottom: 16px;
  width: 100%;
  svg {
    height: 16px;
    width: 16px;
    path {
      stroke: ${props => props.theme.colors.neutral_1};
    }
  }
`;

const StyledExpenseDetailsCollapse = styled(Collapse)`
  .ant-collapse-item {
    .ant-collapse-header {
      ${typographyStyles.body.regular};
      color: ${props => props.theme.colors.neutral_7};
      padding: 8px 0;

      .ant-collapse-header-text {
        .ant-space-item {
          display: flex;
        }

        svg {
          width: 16px;
          height: 16px;

          path {
            stroke: ${props => props.theme.colors.neutral_7};
          }
        }
      }
    }
    .ant-collapse-content {
      .ant-collapse-content-box {
        ${typographyStyles.footnote.description};
        color: ${props => props.theme.colors.neutral_10};
        padding: 0;
      }
    }
  }
`;


export {
  StyledExpenseDetails,
  StyledExpenseDetailsButton,
  StyledExpenseDetailsCollapse,
};
